'use client'

import { blobUrl } from '@/features/v2/constants/variables'

import NavigationStructure from '@/components/navbar/NavigationStructure'

// import Gallery from './Gallery'
import { core } from './localization/core'

const Header = () => {
  return (
    <div className='relative'>
      <NavigationStructure />
      <div
        className='w-full h-96 bg-cover bg-center relative pt-20'
        style={{ backgroundImage: `url('${blobUrl}/ui/casino/bgCasino.webp')` }}
      >
        <h1 className='sr-only'>{core.title}</h1>
        {/* <Gallery /> */}
        <div className='fade-bottom' />
      </div>
    </div>
  )
}

export default Header
